export default __webpack_public_path__ + "static/media/chat_click_metric.076e9d4e.svg";